import React from 'react';
import { getDefault, readCMSValue } from 'modules/shared-cms/utils';
import {
    Actualite,
    BlocActualite,
    Description,
    getNestedReferenceId,
    Showroom,
    TitleBlocContainer,
} from 'modules/shared-cms-advanced';
import { EventProps } from './event-type';

import enhancer from './event-enhancer';

import styles from './event-page.module.css';

const eventPage: React.FC<EventProps> = ({ blocActualite, actualite, prefooter, text, ...rest }: EventProps) => {
    const { titleBlocPicture } = rest;
    const descText = getDefault(readCMSValue(text), '');
    const blocActualiteId = getDefault(getNestedReferenceId(blocActualite), '');
    const actualiteId = getDefault(getNestedReferenceId(actualite), '');
    const prefooterId = getDefault(getNestedReferenceId(prefooter), '');

    return (
        <React.Fragment>
            <div>
                {titleBlocPicture && <TitleBlocContainer {...rest} />}

                {titleBlocPicture && descText !== '' && <div className={styles.separator}></div>}

                {descText !== '' && <Description {...rest} text={descText} />}

                {descText !== '' && blocActualiteId !== '' && <div className={styles.separator}></div>}

                {blocActualiteId !== '' && (
                    <div className={styles.blocActu}>
                        <BlocActualite id={blocActualiteId} />
                    </div>
                )}

                {blocActualiteId !== '' && actualiteId !== '' && <div className={styles.separator}></div>}

                {actualiteId !== '' && <Actualite id={actualiteId} />}

                {prefooterId !== '' && <Showroom id={prefooterId} />}
            </div>
        </React.Fragment>
    );
};

export const EventPage = enhancer(eventPage);
